import * as Yup from "yup";

const phoneNumberValidation = Yup.string()
  .trim()
  .test("phone-number", "無効な電話番号", (value) => {
    const phoneRegexes = {
      Mongolia: /^((\+?976)|0)[6789]\d{7}$/,
      Japan: /^((\+?81)|0)([789]0|4\d{1})\d{4}\d{4}$/,
      USA: /^((\+?1)[ -]?)?\(?\d{3}\)?[ -]?\d{3}[ -]?\d{4}$/,
    };
    for (const [country, regex] of Object.entries(phoneRegexes)) {
      if (value && regex.test(value)) {
        return true;
      }
    }
    return false;
  })
  .required("電話番号が入力されていません");

const emailValidation = Yup.string()
  .trim()
  .email("メールアドレスが無効です")
  .required("メールアドレスが入力されていません");

const usernameValidation = Yup.string()
  .trim()
  .min(1, "ニックネームは1文字以上でなければなりません")
  .max(20, "ニックネームは20文字以内とします")
  .required("ニックネームが入力されていません");

const lastnameValidation = Yup.string()
  .trim()
  .min(1, "名字は1文字以上でお願いします")
  .max(50, "名字は50文字以内でお願いします")
  .required("名字が入力されていません。");

const storeNameValidation = Yup.string()
  .trim()
  .min(1, "店舖名は1文字以上でお願いします")
  .max(50, "店舖名は50文字以内でお願いします")
  .required("店舖名が入力されていません");

const terminalNameValidation = Yup.string()
  .trim()
  .min(1, "端末名(カスタム)は1文字以上でお願いします")
  .max(30, "端末名(カスタム)は30文字以内でお願いします")
  .required("端末名(カスタム)が入力されていません");

const flowRateValidation = Yup.number()
  .transform((value) => (isNaN(value) ? undefined : value))
  .positive("流量は正の数でなければなりません")
  .min(10, "流量は10以上に設定してください")
  .max(100, "流量は100以下に設定してください")
  .required("流量が入力されていません");

const descriptionValidation = Yup.string()
  .trim()
  .min(1, "銘柄は1文字以上でお願いします")
  .max(150, "銘柄は150文字以内でお願いします")
  .required("銘柄が入力されていません");

const singleAmountValidation = Yup.number()
  .transform((value) => (isNaN(value) ? undefined : value))
  .required("単品金額が入力されていません");

const storeSubnameValidation = Yup.string()
  .trim()
  .min(1, "サプ店舗名は1文字以上でお願いします")
  .max(50, "サプ店舗名は50文字以内でお願いします")
  .required("サプ店舗名が入力されていません");

const storeTypeValidation = Yup.string()
  .trim()
  .min(1, "店舖形態は1文字以上でお願いします")
  .max(50, "店舖形態は50文字以内でお願いします")
  .required("店舖形態が入力されていません");

const storeRegionValidation = Yup.string()
  .trim()
  .required("店舗の地域（国）が入力されていません");

const storeLocationStateValidation = Yup.string()
  .trim()
  .required("店舗の地域（都道府県）が入力されていません");

const storeLocationCityValidation = Yup.string()
  .trim()
  .required("店舗の地域（市区町村）が入力されていません");

const firstnameValidation = Yup.string()
  .trim()
  .min(1, "名前は1文字以上でお願いします")
  .max(50, "名前は50文字以内でお願いします")
  .required("名前が入力されていません");

const passwordValidation = Yup.string()
  .trim()
  .min(8, "パスワードは8文字以上でなければなりません")
  .required("パスワードが入力されていません");

const confirmPasswordValidation = Yup.string()
  .trim()
  .oneOf(
    [Yup.ref("password"), ""],
    "新しいパスワードの再確認が新しいパスワードと一致しません"
  )
  .required("パスワードの再確認が入力されていません");

const currentPasswordValidation = Yup.string()
  .trim()
  .min(8, "現在のパスワードは8文字以上でなければなりません")
  .required("現在のパスワードが入力されていません");

const newPasswordValidation = Yup.string()
  .trim()
  .min(8, "新しいパスワードは8文字以上でなければなりません")
  .matches(
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
    "新しいパスワードは、少なくとも1つの数字、1つの大文字、1つの小文字を含む必要があります"
  )
  .required("新しいパスワードが入力されていません");

const genderValidation = Yup.string()
  .trim()
  .required("性別が入力されていません");

const currentAddressValidation = Yup.string()
  .trim()
  .required("現在お住まいの地域が入力されていません");

const currentCountryValidation = Yup.string()
  .trim()
  .required("現在お住まいの国が入力されていません");

const birthDateValidation = Yup.date()
  .nullable()
  .max(new Date(Date.now() - 631065600000), "20歳以上である必要があります")
  .required("生年月日が入力されていません");

const birthAddressValidation = Yup.string()
  .trim()
  .required("出身地（都道府県・市区町村）が入力されていません");

const birthCountryValidation = Yup.string()
  .trim()
  .required("出身地（国）が入力されていません");

const verificationCodeValidation = Yup.string()
  .trim()
  .required("認証コードが必要です。")
  .length(6, "検証コードは正確に6文字である必要があります");

const nameValidation = Yup.string()
  .trim()
  .min(1, "お名前は1文字以上でなければなりません")
  .max(20, "お名前は20文字以内とします")
  .required("お名前が入力されていません");

const messageValidation = Yup.string()
  .trim()
  .min(1, "メッセージは1文字以上でなければなりません。")
  .matches(/^[A-Za-z0-9\s]+$/, "メッセージには、文字と数字のみを使用できます")
  .required("メッセージが入力されていません");

const cardNumberValidation = Yup.string()
  .trim()
  .required("Credit card number is required.")
  .matches(/^\d+$/, "Credit card number must be numeric.")
  .test("test-card-number", "Credit card number is invalid.", (value) => {
    if (!value) {
      return false;
    }
    let sum = 0;
    let double = false;
    for (let i = value.length - 1; i >= 0; i--) {
      let digit = parseInt(value.charAt(i), 10);
      if (double) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }
      sum += digit;
      double = !double;
    }
    return sum % 10 === 0;
  });

const wifiSSIDValidation = Yup.string()
  .trim()
  .max(50, "SSIDは50文字以内でお願いします")
  .required("SSIDが入力されていません");

const wifiPasswordValidation = Yup.string()
  .trim()
  .max(50, "パスワードは50文字以内でお願いします")
  .required("パスワードが入力されていません");

const ticketNameValidation = Yup.string()
  .trim()
  .min(1, "チケット名は1文字以上でお願いします")
  .max(50, "チケット名は50文字以内でお願いします")
  .required("チケット名が入力されていません");

const ticketPriceValidation = Yup.number()
  .transform((value) => (isNaN(value) ? undefined : value))
  .positive("金額は正の数でなければなりません")
  .min(100, "半角数字で100(円)以上を入力してください")
  .required("金額が入力されていません");

const ticketTypeValidation = Yup.string()
  .trim()
  .required("チケットタイプを選択してください");

const ticketQuantityValidation = Yup.number()
  .transform((value) => {
    return isNaN(value) || value === null || value === undefined ? 0 : value;
  })
  .positive("チケット枚数は正の数でなければなりません")
  .required("チケット枚数が入力されていません");

const ticketTypeUsageValidation = Yup.string()
  .trim()
  .required("利用パターンを選択してください");

const ticketCurrencyValidation = Yup.string()
  .trim()
  .required("通貨を選択してください");

const ticketPermissionValidation = Yup.string()
  .trim()
  .required("チケットを表示可能なアプリ領域を選択してください");

const ticketLifespanTypeValidation = Yup.string()
  .trim()
  .required("期限タイプを選択してください");

const ticketLifespanUnitNumValidation = Yup.number()
  .transform((value) => {
    return isNaN(value) || value === null || value === undefined ? 0 : value;
  })
  .positive("期限は正の数でなければなりません")
  .required("期限が入力されていません");

const ticketLifespanUnitTypeValidation = Yup.string()
  .trim()
  .required("オプションを選択してください");

const groupNameValidation = Yup.string()
  .trim()
  .min(1, "グループ名は1文字以上でお願いします")
  .max(50, "グループ名は50文字以内でお願いします。")
  .matches(
    /^[0-9a-zA-Z:_-]+$/,
    "数字、コロン、アンダースコア、ハイフンのみが使用可能です"
  )
  .required("グループ名が入力されていません");

const groupDescriptionValidation = Yup.string()
  .trim()
  .min(1, "グループの説明は1文字以上でお願いします")
  .max(150, "グループの説明は150文字以内でお願いします")
  .optional();

const brandNameValidation = Yup.string()
  .trim()
  .min(1, "ブランド名は1文字以上でお願いします")
  .max(50, "ブランド名は50文字以内でお願いします")
  .required("ブランド名が入力されていません");

const sakeSettingTypeValidation = Yup.string()
  .trim()
  .required("日本酒設定のタイプを選択してください");

const breweryCompanyNameValidation = Yup.string()
  .trim()
  .required("酒蔵会社名が入力されていません");

const breweryNameValidation = Yup.string()
  .trim()
  .required("醸造所名が入力されていません");

const sakeNameValidation = Yup.string()
  .trim()
  .required("お酒の名前が入力されていません");

const sakeSpecifiedNameValidation = Yup.string()
  .trim()
  .required("特定名称酒が入力されていません");

const selectedSakeValidation = Yup.string()
  .trim()
  .required("日本酒を選択してください");

const colorValidation = Yup.string().required("色を選択してください");
const bgColorValidation = Yup.string().required("背景色を選択してください");

const customerNameValidation = Yup.string()
  .trim()
  .min(1, "カスタマー名は1文字以上でなければなりません")
  .max(20, "カスタマー名は20文字以内とします")
  .required("カスタマー名が入力されていません");

const contactPersonNameValidation = Yup.string()
  .trim()
  .min(1, "ご担当者様氏名は1文字以上でなければなりません")
  .max(20, "ご担当者様氏名は20文字以内とします")
  .required("ご担当者様氏名が入力されていません");

const postalCodeValidation = Yup.string()
  .trim()
  .matches(/^\d{7}$/, "無効な郵便番号")
  .required("郵便番号が入力されていません");

const prefecturesValidation = Yup.string()
  .trim()
  .min(1, "都道府県は1文字以上でなければなりません")
  .max(20, "都道府県は20文字以内とします")
  .required("都道府県が入力されていません");

const municipalitiesValidation = Yup.string()
  .trim()
  .min(1, "市区町村以降は1文字以上でなければなりません")
  .max(20, "市区町村以降は20文字以内とします")
  .required("市区町村以降が入力されていません");

const storeSubnameOptionalValidation = Yup.string()
  .trim()
  .nullable()
  .min(2, "サプ店舗名は2文字以上でお願いします")
  .max(50, "サプ店舗名は50文字以内でお願いします")
  .optional();

const storeTypeOptionalValidation = Yup.string()
  .trim()
  .nullable()
  .min(2, "店舖形態は2文字以上でお願いします")
  .max(50, "店舖形態は50文字以内でお願いします")
  .optional();

const postalCodeOptionalValidation = Yup.string()
  .trim()
  .nullable()
  .matches(/^\d{7}$/, "無効な郵便番号")
  .optional();

const prefecturesOptionalValidation = Yup.string()
  .trim()
  .nullable()
  .min(2, "都道府県は2文字以上でなければなりません")
  .max(20, "都道府県は20文字以内とします")
  .optional();

const municipalitiesOptionalValidation = Yup.string()
  .trim()
  .nullable()
  .min(2, "市区町村以降は2文字以上でなければなりません")
  .max(20, "市区町村以降は20文字以内とします")
  .optional();

const adminNameValidation = Yup.string()
  .trim()
  .min(1, "管理者名は1文字以上でなければなりません")
  .max(20, "管理者名は20文字以内とします")
  .required("管理者名が入力されていません");

const adminRoleValidation = Yup.string()
  .trim()
  .required("権限を設定してください");

export {
  phoneNumberValidation,
  emailValidation,
  lastnameValidation,
  firstnameValidation,
  usernameValidation,
  passwordValidation,
  confirmPasswordValidation,
  genderValidation,
  birthDateValidation,
  birthAddressValidation,
  birthCountryValidation,
  currentAddressValidation,
  currentCountryValidation,
  currentPasswordValidation,
  newPasswordValidation,
  verificationCodeValidation,
  nameValidation,
  messageValidation,
  cardNumberValidation,
  storeNameValidation,
  storeSubnameValidation,
  storeTypeValidation,
  storeRegionValidation,
  storeLocationStateValidation,
  storeLocationCityValidation,
  terminalNameValidation,
  flowRateValidation,
  descriptionValidation,
  singleAmountValidation,
  wifiSSIDValidation,
  wifiPasswordValidation,
  ticketNameValidation,
  ticketPriceValidation,
  ticketTypeValidation,
  ticketQuantityValidation,
  ticketTypeUsageValidation,
  ticketCurrencyValidation,
  ticketPermissionValidation,
  ticketLifespanTypeValidation,
  ticketLifespanUnitTypeValidation,
  ticketLifespanUnitNumValidation,
  groupNameValidation,
  groupDescriptionValidation,
  brandNameValidation,
  sakeSettingTypeValidation,
  breweryCompanyNameValidation,
  breweryNameValidation,
  sakeNameValidation,
  sakeSpecifiedNameValidation,
  selectedSakeValidation,
  colorValidation,
  bgColorValidation,
  customerNameValidation,
  contactPersonNameValidation,
  postalCodeValidation,
  prefecturesValidation,
  municipalitiesValidation,
  storeSubnameOptionalValidation,
  storeTypeOptionalValidation,
  postalCodeOptionalValidation,
  prefecturesOptionalValidation,
  municipalitiesOptionalValidation,
  adminRoleValidation,
  adminNameValidation
};
